import { FC, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import { Form as FormAnt, Input, ModalProps, Typography, message } from "antd";
import { Modal } from '@hdi-seguros/web-components.modal';

import InsurancePolicyService from "../../../../../shared/services/insurancePolicy";
import { ElectronicPolicySuscriptionRequest, InsurancePolicy } from "../../../../../shared/interfaces";
import { Column, _renderColumns } from "../../utils/renderSections";

import './index.css';
import { ColSize, RowSize, InputForm, Form } from "../../../../../shared/components";
import { ValidateForm } from "../../../../../shared/utils";

interface SuscribePolicyModalProps extends ModalProps {
    insurancePolicy?: InsurancePolicy
    onClose: () => void;
    onConfirm: (suscription: string, email: string) => void;
}

export const SuscribePolicyModal: FC<SuscribePolicyModalProps> = ({ open, title, onClose, insurancePolicy, onConfirm }) => {

    const { id } = useParams();
    const [form] = FormAnt.useForm();
    const [loading, setLoading] = useState(false);
    const validateForm = new ValidateForm();

    const insuranceColumns: Array<Column> = useMemo(() => [
        {
            label: 'Rama',
            value: insurancePolicy?.descripcionRama
        },
        {
            label: 'Póliza',
            value: id,
        },
        {
            label: 'Asegurado',
            value: insurancePolicy?.nombreAsegurado
        }
    ], [id, insurancePolicy]);

    const onSubmit = async () => {
        try {
            await form.validateFields();
            form.submit();
        } catch (error) { }
    };

    const onSuscribeOnElectronicPolicy = async () => {
        setLoading(true);

        const electronicPolicySuscription: ElectronicPolicySuscriptionRequest = {
            articulo: insurancePolicy!.articulo,
            articuloRamaSecuencia: insurancePolicy!.arse,
            email: form.getFieldValue('email'),
            operacion: insurancePolicy!.operacion,
            poliza: id!,
            rama: insurancePolicy!.rama,
            superpoliza: insurancePolicy!.superpoliza,
            suscripcion: 'S',
        }

        try {
            const response = await InsurancePolicyService.suscribeOnElectronicPolicy(electronicPolicySuscription);

            if (response.data.resultado) {
                message.success('Suscripción a la póliza electrónica realizada con exito!');
                onConfirm(electronicPolicySuscription.suscripcion, electronicPolicySuscription.email);
                onClose();
            }
        } catch (error) {
            message.error(`Hubo un error intentando suscribir la poliza ${id} a la póliza electrónica`);
            onClose()
        } finally {
        }
    };

    const onDesuscribeElectronicPolicy = async () => {
        setLoading(true);

        const electronicPolicySuscription: ElectronicPolicySuscriptionRequest = {
            articulo: insurancePolicy!.articulo,
            articuloRamaSecuencia: insurancePolicy!.arse,
            email: "",
            operacion: insurancePolicy!.operacion,
            poliza: id!,
            rama: insurancePolicy!.rama,
            superpoliza: insurancePolicy!.superpoliza,
            suscripcion: 'N',
        }

        try {
            const response = await InsurancePolicyService.suscribeOnElectronicPolicy(electronicPolicySuscription);

            if (response.data.resultado) {
                message.success(`Se desuscribio la poliza ${id} a la póliza electrónica con exito!`);
                onConfirm(electronicPolicySuscription.suscripcion, electronicPolicySuscription.email);
                onClose();
            }
        } catch (error) {
            message.error(`Hubo un error intentando desuscribir la poliza ${id} a la póliza electrónica`);
            onClose()
        }
    }

    return (
        <Modal
            title={title}
            centered
            open={open}
            width={650}
            onCancel={onClose}
            onOk={insurancePolicy?.suscriptaPolizaElectronica === 'N' ? onSubmit : onDesuscribeElectronicPolicy}
            confirmText={insurancePolicy?.suscriptaPolizaElectronica === 'N' ? 'Suscribir' : 'Desuscribir'}
            footer
            loadingConfirmButton={loading}
            className="suscribe-policy-modal-container"
        >
            {
                insurancePolicy?.suscriptaPolizaElectronica === 'N'
                    ? (
                        <>
                            <RowSize rowProps={{ gutter: [0, 15], justify: 'start' }} className="row-insurance-suscribe-policy">
                                {_renderColumns(insuranceColumns)}
                            </RowSize>

                            <Form
                                formProps={{
                                    form,
                                    name: "suscription-digitial-policy-form",
                                    onFinish: onSuscribeOnElectronicPolicy,
                                    style: { marginBottom: 10 },
                                }}
                            >
                                <RowSize rowProps={{ gutter: [0, 0] }}>
                                    <ColSize size={100}>
                                        <InputForm
                                            formProps={{
                                                label: "Ingrese email:",
                                                name: "email",
                                                rules: validateForm.generateRules({
                                                    label: 'ingrese email',
                                                    rules: ['required'],
                                                })
                                            }}
                                            inputProps={{
                                                placeholder: "@mail.com",
                                                type: "email",
                                            }}
                                        />
                                    </ColSize>
                                </RowSize>
                            </Form>
                        </>
                    )
                    : (
                        <>
                            <RowSize
                                rowProps={{ gutter: [0, 0], justify: 'end', align: 'middle' }}
                                className="row-pop-up-suscribe-policy"
                            >
                                <ColSize size={100}>
                                    <Typography.Text>
                                        La poliza
                                        <Typography.Text strong> {id} </Typography.Text>
                                        se encuentra suscripta al servicio de póliza electrónica a través del correo electrónico
                                        <Typography.Text strong> {insurancePolicy?.mailPolizaElectronica} </Typography.Text>
                                        ¿Esta seguro que desea desuscribirse al servicio de póliza electrónica?
                                    </Typography.Text>
                                </ColSize>
                            </RowSize>
                        </>
                    )
            }

        </Modal>
    )
}
